<script>
export default {
  name: "RecruitInfo",
  props: {
    isReverse: { type: Boolean, default: false },
    to: { type: String,default: '' },
    title: { type: String, default: '' },
    heading: {type: String, default: ''},
    paragraph: { type:String, default: '' },
    image: { type: String, default: '' }
  }
}
</script>

<template>
  <div class="recruit-info" :class="[{'is-reverse': isReverse}]">
    <div >
      <span>
        {{title}}
        <img src="@/assets/img/career/icon-arrow-right-blue.svg"  alt="⼊社の経緯"/>
      </span>
      <h3>{{heading}}</h3>
      <div>
        <picture>
          <source :srcset="image"
                  media="(min-width: 901px)">
          <source :srcset="image"
                  media="(max-width: 900px)">
          <img :src="image" alt="" />
        </picture>
      </div>
      <p data-aos="fade-up">
        {{paragraph}}
      </p>
    </div>
    <picture>
      <source :srcset="image"
              media="(min-width: 901px)">
      <source :srcset="image"
              media="(max-width: 900px)">
      <img :src="image" alt="" />
    </picture>
  </div>
</template>

<style scoped lang="scss">
.recruit-info{
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  column-gap: 114px;
  margin-bottom: 110px;
  transition: all ease-in-out .5s;
  @media print, screen and (max-width: 900px) {
    flex-direction: column;
    margin-bottom: 76px;
  }

  @media print, screen and (min-width: 901px) and (max-width: 1120px) {
    column-gap: 40px;
  }
  & > div{
    width: clamp(400px, 50% , 480px);
    box-sizing: border-box;
    transition: all ease-in-out .5s;
    @media print, screen and (max-width: 900px) {
      max-width: 100%;
      min-width: 100%;
    }
    & > span{
      font-size: 20px;
      font-weight: 700;
      color: var(--darkBlue);
      width: fit-content;
      display: flex;
      flex-direction: column;
      line-height: normal;
      & > img{
        width: 100%;
        object-fit: cover;
      }

      @media print, screen and (max-width: 900px) {
        margin-left: 24px;
        font-size: 15px;

        & > img{
          width: 86px;
        }
      }
    }

    & > h3{
      margin: 36px 0 80px 0 ;
      font-size: 34px;
      font-weight: 700;
      color: #3C3C3C;
      line-height: 55px;
      //word-break: keep-all;
    white-space: pre-line;

      @media print, screen and (max-width: 900px) {
        font-size: 20px;
        margin: 32px auto;
        // padding: 0 24px;
        width: 90%;
        white-space: pre-wrap;
        line-height: 41px;
        //word-break: normal;
      }

      @media print, screen and (max-width: 456px) {
        font-size: 19px;
      }
    }

    & > p{
      color: #3C3C3C;
      font-size: 16px;
      font-weight: 500;
      line-height: 36px;
      margin: 0 auto;
      width: 90%;

      @media print, screen and (max-width: 900px) {
        font-size: 15px;
        // padding: 0 24px;
        line-height: 200%;
      }
    }

    & > div{
      display: none;
      @media print, screen and (max-width: 900px) {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 50px;
        & > picture{
          width: 83.33%;
          overflow: hidden;
          border-bottom-left-radius: 24px;
          border-top-left-radius: 24px;
          aspect-ratio: 400/310;
          & > img {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  & > picture{
    width: 45%;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    overflow: hidden;
    aspect-ratio: 616/476;
    transition: all ease-in-out .5s;
    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @media print, screen and (max-width: 900px) {
      display: none;
    }

  }

  &:is(.is-reverse){
    flex-direction: row-reverse;

    & > picture{
      border-radius: 0 24px 24px 0;
    }

    & > div{
      & > div{
        @media print, screen and (max-width: 900px) {justify-content: flex-start;}

        & > picture{
          border-radius: 0 24px 24px 0;
        }
      }
    }
  }
}
</style>
